import { OBJECT_TYPES } from '../types'

export const ProcessDiagram_MIN_SIZE = { width: 200, height: 200 }

export class ProcessDiagramClass {
    constructor(id, title, x, y, width, height, processDiagramProps, wrapperStyles) {
        this.id = id
        this.title = title
        this.x = x
        this.y = y
        this.width = width
        this.height = height
        this.isBlank = true
        this.type = OBJECT_TYPES.PROCESS
        this.content = {
            processDiagramID: processDiagramProps?.processDiagramID || null,
        }
        this.wrapperStyles = wrapperStyles || {}
    }

    // initialize w sample data from a working chart
    static newProcessDiagram(title, processDiagramProps, zoom, wrapperStyles, x, y) {
        const canvasScrollElement = document.getElementById('canvas-scrollable')
        return new ProcessDiagramClass(
            Math.random(),
            title || 'My Process Diagram',
            x ? x : (200 + (canvasScrollElement ? canvasScrollElement.scrollLeft : 0)) / zoom,
            y ? y : (200 + (canvasScrollElement ? canvasScrollElement.scrollTop : 0)) / zoom,
            800,
            500,
            processDiagramProps,
            wrapperStyles
        )
    }
}
